var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmfArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.026,
    height: 26.742,
    viewBox: "0 0 43.026 26.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7060",
    "data-name": "Grupo 7060",
    transform: "translate(1.789 -0.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_1",
    "data-name": "Uni\\xF3n 1",
    d: "M9.545,26.177-.536,16.813a4,4,0,0,1,0-5.862L9.545,1.589a4.005,4.005,0,0,1,6.624,2.025H39.212a2,2,0,0,1,2,2V22.151a2,2,0,0,1-2,2H16.169a4.019,4.019,0,0,1-3.928,3.1A3.923,3.923,0,0,1,9.545,26.177Z",
    transform: "translate(0.025 -0.128)",
    fill: "#13a438"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo_CMF",
    "data-name": "Logo CMF",
    transform: "translate(13.693 13.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6512",
    "data-name": "Grupo 6512",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6510",
    "data-name": "Grupo 6510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2259",
    "data-name": "Trazado 2259",
    d: "M35.35,27.163a4.244,4.244,0,0,1,7.776-2.27l-1.8,1.015A1.91,1.91,0,0,0,39.6,25a2.167,2.167,0,1,0,0,4.335,1.9,1.9,0,0,0,1.722-.924l1.8,1.027a4.243,4.243,0,0,1-7.776-2.27Z",
    transform: "translate(-35.35 -23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2260",
    "data-name": "Trazado 2260",
    d: "M286.8,35.955H284.73v-4.3l-1.979,3.205h-.209l-1.968-3.194v4.289H278.49V27.97h2.084l2.072,3.411,2.084-3.411H286.8v7.985Z",
    transform: "translate(-269.968 -27.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2261",
    "data-name": "Trazado 2261",
    d: "M554.634,29.944v1.3H557.5v1.974h-2.863v2.738H552.55V27.97h5.006v1.973h-2.922Z",
    transform: "translate(-534.422 -27.799)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6511",
    "data-name": "Grupo 6511",
    transform: "translate(23.265 6.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2262",
    "data-name": "Trazado 2262",
    d: "M700.6,217.139a.9.9,0,0,1-1.231-.006.817.817,0,0,1-.252-.608.808.808,0,0,1,.272-.623.865.865,0,0,1,.6-.232.849.849,0,0,1,.617.251.845.845,0,0,1-.006,1.218Zm-1.124-1.109a.7.7,0,0,0,0,1,.725.725,0,0,0,1.017,0,.685.685,0,0,0,.211-.5.677.677,0,0,0-.21-.5.717.717,0,0,0-1.021,0Zm.13.971v-.948h.269l.2,0a.473.473,0,0,1,.191.049.238.238,0,0,1,.129.226.207.207,0,0,1-.068.173.321.321,0,0,1-.168.064.333.333,0,0,1,.137.055.255.255,0,0,1,.085.213v.085a.178.178,0,0,0,0,.028.136.136,0,0,0,.007.028l.009.027h-.241a.675.675,0,0,1-.016-.131.424.424,0,0,0-.016-.116.117.117,0,0,0-.071-.07.3.3,0,0,0-.087-.015l-.056,0h-.053V217Zm.462-.761a.433.433,0,0,0-.147-.02h-.062v.275h.1a.239.239,0,0,0,.138-.035.128.128,0,0,0,.05-.113A.108.108,0,0,0,700.072,216.239Z",
    transform: "translate(-699.12 -215.67)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2668",
    "data-name": "Rect\\xE1ngulo 2668",
    d: "M2,0H23.276a2,2,0,0,1,2,2V8.033a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(13.428 4.858)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Precio",
    transform: "translate(26.198 10.858)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "AvenirNextLTPro-Medium, Avenir Next LT Pro",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "Precio")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmfArrow);
export default __webpack_public_path__ + "static/media/cmf_arrow.45c61e2d75058ac07d8305adb4e744ff.svg";
export { ForwardRef as ReactComponent };